import React, { Fragment } from 'react'
import Loadable from 'react-loadable'
import { DI } from 'modules'
import HelmetWrap from 'components/helmet-wrap'
import HTMLTranslation from 'components/html-translation'
import page from 'hoc/page'
import frontload from 'hoc/frontload'

import 'submodules/responsivestyles/src/less/about.less'
import { IS_LANDING } from 'config'

const loading = () => null

const en = Loadable({
  loading,
  loader: () =>
    IS_LANDING
      ? import(
          /* webpackChunkName: "privacy-policy-ru" */ 'submodules/translations/static-pages/privacy-policy-landing/en'
        )
      : import(
          /* webpackChunkName: "privacy-policy-en" */ 'submodules/translations/static-pages/privacy-policy/en'
        ),
})
const ru = Loadable({
  loading,
  loader: () =>
    IS_LANDING
      ? import(
          /* webpackChunkName: "privacy-policy-ru" */ 'submodules/translations/static-pages/privacy-policy-landing/ru'
        )
      : import(
          /* webpackChunkName: "privacy-policy-ru" */ 'submodules/translations/static-pages/privacy-policy/ru'
        ),
})
const es = Loadable({
  loading,
  loader: () =>
    IS_LANDING
      ? import(
          /* webpackChunkName: "privacy-policy-es" */ 'submodules/translations/static-pages/privacy-policy-landing/es'
        )
      : import(
          /* webpackChunkName: "privacy-policy-es" */ 'submodules/translations/static-pages/privacy-policy/es'
        ),
})
const ar = Loadable({
  loading,
  loader: () =>
    IS_LANDING
      ? import(
          /* webpackChunkName: "privacy-policy-ar" */ 'submodules/translations/static-pages/privacy-policy-landing/ar'
        )
      : import(
          /* webpackChunkName: "privacy-policy-ar" */ 'submodules/translations/static-pages/privacy-policy/ar'
        ),
})

export class PrivacyPolicyPage extends React.Component {
  static preload(props) {
    const slug = 'privacy'
    return props.actions.frontpages.getFrontPage(slug)
  }

  render() {
    const meta_tag = this.props.frontpages.info.payload.meta_tag
    const strings = this.props.common.strings

    return (
      <Fragment>
        <HelmetWrap {...(meta_tag || {})} page="privacy" />

        <section className="content">
          <div className="iwrap not-found-page">
            <div className="about-container">
              <HTMLTranslation translations={{ en, ru, es, ar }} />
              <div style={{ textAlign: 'right', marginTop: '30px' }}>
                {strings.last_updated_at || 'Last updated at '} 23.08.2022
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default page(
  DI(['frontpages'])(frontload(PrivacyPolicyPage, 'privacyPolicyPage'))
)
